import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import styled, { css } from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';

export const RatingCount = styled.span<{ onClick?: () => void }>`
    margin-left: 4px;

    ${({ onClick }) =>
        !!onClick &&
        css`
            color: ${Palette.state.info};
            text-decoration: underline;
            cursor: pointer;
        `}
`;

export const RatingText = styled.span`
    margin-right: 4px;
    font-weight: 500;
`;

export const NoReviews = styled.div<{ tooltip?: boolean }>`
    color: ${Palette.sand.darkSand};

    ${({ tooltip }) =>
        tooltip &&
        css`
            text-decoration: underline;
        `}
`;

export const Reviews = styled.div<{ size?: 'medium'; whiteMode?: boolean }>`
    display: flex;
    align-items: center;
    color: ${cssVars.fg_gray2_gray3};

    ${({ size }) => {
        if (size === 'medium') {
            return css`
                ${Text.Mobile.medium.medium}

                ${Screen.ipad} {
                    ${Text.Ipad.medium.regular};
                }
                ${Screen.desktop} {
                    ${Text.Desktop.large.regular};
                }
            `;
        }

        return '';
    }}

    ${({ whiteMode }) =>
        whiteMode &&
        css`
            color: ${Palette.white.normal} !important;
        `}
`;
